import { quoteCsvCell } from './csvExport';

const quoteCurrencyCell = (value, formatCurrency) => {
  if (value === null || value === undefined) return quoteCsvCell('');
  const formatted = String(formatCurrency(value));
  // This narrow, fully numeric currency shape is produced by the existing
  // formatter. Keep negative amounts usable as numbers, not apostrophe text.
  if (/^-?\$(?:\d{1,3}(?:,\d{3})+|\d+)\.\d{2}$/.test(formatted)) {
    return `"${formatted}"`;
  }
  return quoteCsvCell(formatted);
};

export const buildHomepageCasesCsv = (cases, {
  isSettlementsView,
  formatDatePreservingDay,
  formatLastModified,
  formatCurrency,
}) => {
  const headers = isSettlementsView
    ? ['Case Name', 'Client', 'Attorney', 'Settlement Date', 'Settlement Amount', 'Net Attorney Fees']
    : ['Role Name', 'Case Name', 'Phase', 'Created', 'Last Updated'];
  const rows = cases.map((caseItem) => {
    if (isSettlementsView) {
      return [
        quoteCsvCell(caseItem.case_name || ''),
        quoteCsvCell(caseItem.client_name || ''),
        quoteCsvCell(caseItem.attorney_name || ''),
        quoteCsvCell(caseItem.settlement_date ? formatDatePreservingDay(caseItem.settlement_date) : ''),
        quoteCurrencyCell(caseItem.settlement_amount, formatCurrency),
        quoteCurrencyCell(caseItem.net_attorney_fees, formatCurrency),
      ].join(',');
    }
    return [
      quoteCsvCell(Array.isArray(caseItem.role_names) ? (caseItem.role_names[0] || '') : ''),
      quoteCsvCell(caseItem.case_name || ''),
      quoteCsvCell(caseItem.phase_name || caseItem.phase || ''),
      quoteCsvCell(caseItem.create_date ? formatLastModified(caseItem.create_date)[5] : ''),
      quoteCsvCell(caseItem.updated_at ? formatLastModified(caseItem.updated_at)[5] : ''),
    ].join(',');
  });
  return [headers.join(','), ...rows].join('\n');
};
